module.exports = __webpack_public_path__ + "static/media/whiteArrow.58c2b61d.svg";